import React from 'react';
import { Modal, Upload, message } from 'antd';
import { useParams } from 'react-router-dom';
import { useCanvas } from '../../context/canvasContext';
import { useDocument } from '../../context/documentInfoContex';
import { UploadIcon } from './icons';
import './UploadModal.css';

const Heading = () => (
    <div className="upload-image-modal__heading">
        <span className="upload-image-modal__badge"><UploadIcon /></span>
        <span className="upload-image-modal__text">
            <span className="upload-image-modal__title">Upload image</span>
            <span className="upload-image-modal__subtitle">Add a picture to the board</span>
        </span>
    </div>
);

/** Drag-and-drop image upload; closes itself once an image lands on the board. */
const UploadModal = ({ open, onClose }) => {
    const { id } = useParams();
    const { createImage } = useCanvas();
    const { setSavingData, isTemplateDocument } = useDocument();

    const handleChange = async ({ file }) => {
        if (file.status === 'error') {
            message.error(`${file.name} upload failed.`);
            return;
        }
        if (file.status !== 'uploading' || !file.originFileObj) return;
        try {
            const added = await createImage(file.originFileObj, id, setSavingData, isTemplateDocument);
            if (added) {
                onClose();
                message.success(`${file.name} added to board.`);
            }
        } catch (error) {
            console.error('Error adding image:', error);
            message.error(`Failed to process ${file.name}.`);
        }
    };

    return (
        <Modal
            title={<Heading />}
            visible={open}
            onCancel={onClose}
            footer={null}
            maskClosable
            centered
            width={400}
            className="upload-image-modal"
        >
            <Upload.Dragger accept="image/*" customRequest={() => {}} showUploadList={false} multiple onChange={handleChange}>
                <span className="upload-image-modal__drop-icon"><UploadIcon /></span>
                <p className="upload-image-modal__drop-text">Click or drag an image here</p>
                <p className="upload-image-modal__drop-hint">PNG, JPG or GIF</p>
            </Upload.Dragger>
        </Modal>
    );
};

export default UploadModal;
